var map = {
	"./cityair-has-verified-air-quality-data-from-airquality.report-and-agreed-on-project-integration-into-the--airvoice-platform.jpg": 7515,
	"./empty_news.jpg": 5577,
	"./empty_news_2.jpeg": 2086,
	"./how-cityair-monitors-may-be-used-for-volcanic-eruptions-control-and-notifications.jpg": 5177,
	"./krasnoyarsk.jpg": 6675,
	"./moment_1.jpg": 9439,
	"./moment_2.jpg": 995,
	"./moment_3.jpg": 4611,
	"./moment_4.jpg": 2071,
	"./sakhalin.jpg": 5289,
	"./vtu.jpg": 3201,
	"./whoosh-and-cityair-launched-kick-scooters-with-air-quality-sensors.jpg": 2812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9394;